import { BlacklistUserInfoData } from '../components/transactions-sidepanels/types';
import formatBalance from './format-balance';
import formatDate from './format-date';

const formatBlacklistItem = (blacklistData: BlacklistUserInfoData) => {
  const nextBalcklistData: BlacklistUserInfoData = {
    ...blacklistData,
    source: {
      ...blacklistData?.source,
      name:
        blacklistData?.source?.firstName || blacklistData?.source?.lastName
          ? `${blacklistData?.source?.firstName || ''} ${
              blacklistData?.source?.lastName || ''
            }`
          : blacklistData?.source?.name || '-',
      entityAddresses: blacklistData?.source?.entityAddresses?.map(
        (item, index) => ({
          ...item,
          id: item.entityAddressGUID || `entityAddresses-${index}`,
          lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
          address1: item?.address1 || '—',
          address2: item?.address2 || '—',
          city: item?.city || '—',
          country: item?.country || '—',
          isoStandard: item?.isoStandard || '—',
        }),
      ),
      entityAliases: blacklistData?.source?.entityAliases?.map(
        (item, index) => ({
          ...item,
          id: item?.entityAliasGUID || `entityAliases-${index}`,
          aliasTypeDesc: item?.aliasTypeDesc || '—',
          englishDescription: item?.englishDescription || '—',
          entityAliasGUID: item?.entityAliasGUID || '—',
          firstName: item?.firstName || '—',
          lastName: item?.lastName || '—',
          lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
          middleName: item?.middleName || '—',
          name: item?.name || '—',
        }),
      ),
      entityCountryAssociations:
        blacklistData?.source?.entityCountryAssociations?.map(
          (item, index) => ({
            ...item,
            id:
              item.entityCountryAssociationGUID ||
              `entityCountryAssociations-${index}`,
            administrativeUnitName: item?.administrativeUnitName || '—',
            associationTypeDesc: item?.associationTypeDesc || '—',
            entityCountryAssociationGUID:
              item?.entityCountryAssociationGUID || '—',
            isoStandard: item?.isoStandard || '—',
            lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
            ownershipPercentageCalc: item?.ownershipPercentageCalc
              ? formatBalance(Number(item.ownershipPercentageCalc))
              : '—',
          }),
        ),
      entityIdentifications: blacklistData?.source?.entityIdentifications?.map(
        (item, index) => ({
          ...item,
          id: item.entityIdentificationGUID || `entityIdentifications-${index}`,
          administrativeUnitName: item?.administrativeUnitName || '—',
          entityIdentificationGUID: item?.entityIdentificationGUID || '—',
          expirationDateValue: `${
            item.expirationDate?.expirationYear || 'xxxx'
          }-${
            item?.expirationDate?.expirationMonth &&
            Number(item?.expirationDate?.expirationMonth) < 10
              ? '0'
              : ''
          }${item?.expirationDate?.expirationMonth || 'xx'}-${
            item?.expirationDate?.expirationDay &&
            Number(item?.expirationDate?.expirationDay) < 10
              ? '0'
              : ''
          }${item?.expirationDate?.expirationDay || 'xx'}`,
          identificationIssuer: item?.identificationIssuer || '—',
          identificationNumber: item?.identificationNumber || '—',
          identificationTypeDesc: item?.identificationTypeDesc || '—',
          isoStandard: item?.isoStandard || '—',
          issueDateValue: `${item.issueDate?.issueYear || 'xxxx'}-${
            item?.issueDate?.issueMonth &&
            Number(item?.issueDate?.issueMonth) < 10
              ? '0'
              : ''
          }${item?.issueDate?.issueMonth || 'xx'}-${
            item?.issueDate?.issueDay && Number(item?.issueDate?.issueDay) < 10
              ? '0'
              : ''
          }${item?.issueDate?.issueDay || 'xx'}`,
          lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
        }),
      ),
      entityPositions: blacklistData?.source?.entityPositions?.map(
        (item, index) => ({
          ...item,
          id: item.entityPositionGUID || `entityPositions-${index}`,
          entityPositionGUID: item.entityPositionGUID || '—',
          lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
          position: item.position || '—',
        }),
      ),
      entityRelationships: blacklistData?.source?.entityRelationships?.map(
        (item, index) => ({
          ...item,
          id: item.entityRelationshipGUID || `entityRelationships-${index}`,
          entityRelationshipGUID: item?.entityRelationshipGUID || '—',
          groupDesc: item?.groupDesc || '—',
          lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
          ownershipPercentage: item?.ownershipPercentage
            ? formatBalance(Number(item.ownershipPercentage))
            : '—',
          relatedEntityGUID: item?.relatedEntityGUID,
          relationshipDesc: item?.relationshipDesc || '—',
        }),
      ),
      entityRemarks: blacklistData?.source?.entityRemarks?.map(
        (item, index) => ({
          ...item,
          entityRemarkGUID: item.entityRemarkGUID || `entityRemarks-${index}`,
          lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
          remark: item?.remark || '—',
        }),
      ),
      entitySourceItems: blacklistData?.source?.entitySourceItems?.map(
        (item, index) => ({
          ...item,
          entitySourceItemGUID:
            item?.entitySourceItemGUID || `entitySourceItems-${index}`,
          sourceURI: item?.sourceURI || '—',
          lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
        }),
      ),
      entitySegments: {
        ...blacklistData?.source?.entitySegments,
        entityAdverseMedias:
          blacklistData?.source?.entitySegments?.entityAdverseMedias?.map(
            (item, index) => ({
              ...item,
              entityAdverseMediaGUID:
                item?.entityAdverseMediaGUID || `entityAdverseMedias-${index}`,
              subCategories: item?.entityAdverseMediaSubcategories
                ?.map((subCategory) => subCategory?.subCategoryLabel)
                ?.join('; '),
              lastUpdated: item?.lastUpdated
                ? formatDate(item.lastUpdated)
                : '—',
            }),
          ),
        entityEnforcements:
          blacklistData?.source?.entitySegments?.entityEnforcements?.map(
            (item, index) => ({
              ...item,
              entityEnforcementGUID:
                item?.entityEnforcementGUID || `entityEnforcements-${index}`,
              subCategories: item?.entityEnforcementSubcategories
                ?.map((subCategory) => subCategory?.subCategoryLabel)
                ?.join('; '),
              lastUpdated: item?.lastUpdated
                ? formatDate(item.lastUpdated)
                : '—',
            }),
          ),
        entityPEPs: blacklistData?.source?.entitySegments?.entityPEPs?.map(
          (item, index) => ({
            ...item,
            id: item?.entityPEPGUID || `entityPEPs-${index}`,
            effectiveDateValue: `${
              item.effectiveDate?.effectiveYear || 'xxxx'
            }-${
              item?.effectiveDate?.effectiveMonth &&
              Number(item?.effectiveDate?.effectiveMonth) < 10
                ? '0'
                : ''
            }${item?.effectiveDate?.effectiveMonth || 'xx'}-${
              item?.effectiveDate?.effectiveDay &&
              Number(item?.effectiveDate?.effectiveDay) < 10
                ? '0'
                : ''
            }${item?.effectiveDate?.effectiveDay || 'xx'} ${
              item?.effectiveDateTypeDesc
                ? `(${item.effectiveDateTypeDesc})`
                : ''
            }`,
            effectiveDateTypeDesc: item?.expirationDateTypeDesc || '—',
            entityPEPGUID: item?.entityPEPGUID || '—',
            expirationDateValue: `${
              item.expirationDate?.expirationYear || 'xxxx'
            }-${
              item?.expirationDate?.expirationMonth &&
              Number(item?.expirationDate?.expirationMonth) < 10
                ? '0'
                : ''
            }${item?.expirationDate?.expirationMonth || 'xx'}-${
              item?.expirationDate?.expirationDay &&
              Number(item?.expirationDate?.expirationDay) < 10
                ? '0'
                : ''
            }${item?.expirationDate?.expirationDay || 'xx'} ${
              item?.expirationDateTypeDesc
                ? `(${item?.expirationDateTypeDesc})`
                : ''
            }`,
            expirationDateTypeDesc: item?.expirationDateTypeDesc || '—',
            governingInstitution: item?.governingInstitution || '—',
            governingRole: item?.governingRole || '—',
            isActivePEP: item?.isActivePEP || '—',
            isInCountryPEPOnly: item?.isInCountryPEPOnly || '—',
            isPrimaryPEP: item?.isPrimaryPEP || '—',
            isoAdministrativeUnitLevel0:
              item?.isoAdministrativeUnitLevel0 || '—',
            lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
            pepAdminLevelDesc: item?.pepAdminLevelDesc || '—',
            flags:
              item.isActivePEP === 'Y' || item?.isPrimaryPEP === '1'
                ? `${item?.isPrimaryPEP === '1' ? 'Primary' : ''}${
                    item.isActivePEP === 'Y' ? `; Active` : ''
                  }`
                : '—',
          }),
        ),
        entitySanctions:
          blacklistData?.source?.entitySegments?.entitySanctions?.map(
            (item, index) => ({
              ...item,
              id: item.entitySanctionGUID || `entitySanctions-${index}`,
              administrativeUnitName: item?.administrativeUnitName || '—',
              consolidated: item?.consolidatedSanction ? 'Yes' : 'No',
              designations:
                item?.entitySanctionDesignations &&
                item?.entitySanctionDesignations?.length
                  ? item?.entitySanctionDesignations
                      ?.map(
                        (designation) =>
                          `${designation?.designationName} / ${designation?.subDesignationName}`,
                      )
                      ?.join('; ')
                  : '—',
              entitySanctionGUID: item?.entitySanctionGUID || '—',
              isoStandard: item?.isoStandard || '—',
              lastUpdated: item?.lastUpdated
                ? formatDate(item.lastUpdated)
                : '—',
              sourceName: item?.sourceName || '—',
              sourceNameAbbrev: item?.sourceNameAbbrev || '—',
            }),
          ),
        entitySOEs: blacklistData?.source?.entitySegments?.entitySOEs?.map(
          (item, index) => ({
            ...item,
            id: item.entitySOEGUID || `entitySOEs-${index}`,
            domains:
              item?.entitySOEDomains &&
              item?.entitySOEDomains?.length &&
              item?.entitySOEDomains?.filter((domain) => domain.soeDomainDesc)
                ?.length
                ? item?.entitySOEDomains
                    ?.map((domain) => domain?.soeDomainDesc)
                    ?.join('; ')
                : '—',
            entitySOEGUID: item?.entitySOEGUID || '—',
            subCategories:
              item?.entitySOESubcategories &&
              item?.entitySOESubcategories?.length &&
              item?.entitySOESubcategories?.filter(
                (category) => category?.subCategoryLabel,
              )?.length
                ? item?.entitySOESubcategories
                    ?.map((category) => category?.subCategoryLabel)
                    ?.join('; ')
                : '—',
            isActive: item?.isActive === '1' ? 'Active' : 'Inactive',
            lastUpdated: item?.lastUpdated ? formatDate(item.lastUpdated) : '—',
          }),
        ),
        additionalSegments:
          blacklistData?.source?.entitySegments?.additionalSegments?.map(
            (item) => ({
              ...item,
              additionalSegmentFields: item?.additionalSegmentFields?.map(
                (segment, index) => ({
                  ...segment,
                  id: `${item?.type
                    ?.split(' ')
                    ?.join('-')
                    ?.toLowerCase()}-${index}`,
                }),
              ),
            }),
          ),
      },
    },
  };

  return nextBalcklistData;
};

export default formatBlacklistItem;
